import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/PrincipalPage.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Principal',
    component: Home
  },
  {
    path: '/success',
    name: 'Success',
    component: () => import('@/views/SuccessPage.vue')
  },
  {
    path: '/carrito',
    name: 'Carrito',
    component: () => import('@/views/CarritoPage.vue')
  },
  {
    path: '/articulo/agregar/:id',
    name: 'Articulo',
    component: () => import('@/views/ArticuloPage.vue')
  },
  {
    path: '/articulos',
    name: 'Articulos',
    component: () => import('@/views/ImageUpload.vue')
  },
  {
    path: '/vendedores',
    name: 'Vendores',
    component: () => import('@/views/LoginPage.vue')
  },
  {
    path: '/pedidos',
    name: 'Pedidos',
    component: () => import('@/views/PedidoPage.vue')
  },
  {
    path: '/pedidos/edit/:id',
    name: 'PedidosEdit',
    component: () => import('@/views/PedidoEditPage.vue')
  },
  {
    path: '/pedidos/add',
    name: 'PedidosAdd',
    component: () => import('@/views/PedidoEditPage.vue')
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name === 'Articulos') {
    const token = window.sessionStorage.getItem('token')
    if (!token) {
      next({ name: 'Vendores' })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
